// The individually grabbable parts of the move gizmo: three axis arrows and the three plane quads
// sitting in the corners between them. Each plane is named after the two axes it spans, and is
// drawn in the colour of the third (its normal), matching the usual translate-gizmo convention.
enum MoveGizmoPartEnum {
    AxisX,
    AxisY,
    AxisZ,
    PlaneXY,
    PlaneYZ,
    PlaneZX
}

export default MoveGizmoPartEnum;
